import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
const SidebarFloatingTooltip = ({
  visible,
  text,
  targetRect,
  sidebarRect,
  isSuppressed,
}) => {
  const tooltipRef = useRef(null);
  const [tooltipHeight, setTooltipHeight] = useState(32);

  useLayoutEffect(() => {
    if (tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect();
      if (rect.height && rect.height !== tooltipHeight) {
        setTooltipHeight(rect.height);
      }
    }
  }, [text, visible, tooltipHeight]);

  if (!visible || !text || !targetRect || isSuppressed || typeof document === "undefined") {
    return null;
  }

  const sRight = sidebarRect ? sidebarRect.right : targetRect.right;
  const left = sRight + 10;
  const centerY = targetRect.top + targetRect.height / 2;
  const calculatedTop = centerY - tooltipHeight / 2;

  // Viewport clamping with safe margin (min 18px from top and bottom)
  const minTop = 18;
  const maxTop = Math.max(minTop, (window.innerHeight || 800) - tooltipHeight - 18);
  const clampedTop = Math.max(minTop, Math.min(calculatedTop, maxTop));

  // Arrow notch position relative to the tooltip box
  const rawArrowTop = centerY - clampedTop;
  const clampedArrowTop = Math.max(8, Math.min(rawArrowTop, tooltipHeight - 8));

  return ReactDOM.createPortal(
    <div
      ref={tooltipRef}
      className="sidebar-floating-tooltip"
      role="tooltip"
      aria-hidden="true"
      style={{
        position: "fixed",
        top: `${clampedTop}px`,
        left: `${left}px`,
        zIndex: 100050,
        pointerEvents: "none",
      }}
    >
      <div className="sidebar-floating-tooltip__content">{text}</div>
      <div
        className="sidebar-floating-tooltip__arrow"
        style={{
          top: `${clampedArrowTop}px`,
        }}
      />
    </div>,
    document.body
  );
};

export default SidebarFloatingTooltip;

